export const FETCH_RB_HISTORY_DATA = "FETCH_RB_HISTORY_DATA";
export const RB_HISTORY_DATA_FETCHED = "RB_HISTORY_DATA_FETCHED";
export const RB_HISTORY_DATA_FETCHING_FAILED = "RB_HISTORY_DATA_FETCHING_FAILED";
